const authenticateUser = (state = {}, action) => {
    if (action.type === "authenticateUser") {
      return state  =  action.payload;
    }
   else {
      return state;
    }
  };
  export default authenticateUser;
  